import React from "react";
import { AiOutlineMan } from "react-icons/ai";
// import { FaChild } from 'react-icons/fa';
// import { GiJewelCrown } from 'react-icons/gi';
// import { MdSportsBaseball } from 'react-icons/md';
import styled from "styled-components";
import { getAllCategory } from "../Api/Api";
import { useQuery } from "@tanstack/react-query";

import { Link } from "react-router-dom";
const ProductCats = () => {
  const getCategories = useQuery({
    //  queryKey : ["allcategories"],
    queryFn: getAllCategory,
  });

  // console.log("this is all cat" , getCategories?.data?.data)

  const categories = getCategories?.data?.data;

  console.log("this is categories", categories);

  return (
    <div>
      <Container>
        <ExploreHold>
          {categories?.map((el: any) => (
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to={`/categories/${el?._id}`}
            >
              <Hold>
                <AiOutlineMan style={{ marginRight: "10px" }} />
                <span>{el?.name}</span>
              </Hold>
            </Link>
          ))}

          {/* <Hold>
            <AiOutlineWoman style={{ marginRight: "10px" }} />
            <span>Condiments</span>
          </Hold>
          <Hold>
            <FaChild style={{ marginRight: "10px" }} />
            <span>Fresh Meat</span>
          </Hold>
          <Hold>
            <MdSportsBaseball style={{ marginRight: "10px" }} />
            <span>Groceries</span>
          </Hold>
          <Hold>
            <GiJewelCrown style={{ marginRight: "10px" }} />
            <span>HouseHold Items</span>
          </Hold>
          <Hold>
            <GiJewelCrown style={{ marginRight: "10px" }} />
            <span>Toiletries</span>
          </Hold>
          <Hold>
            <GiJewelCrown style={{ marginRight: "10px" }} />
            <span>Vegetables</span>
          </Hold>
          <Hold>
            <GiJewelCrown style={{ marginRight: "10px" }} />
            <span>Tubers</span>
          </Hold>
          <Hold>
            <GiJewelCrown style={{ marginRight: "10px" }} />
            <span>Flours</span>
          </Hold>
          <Hold>
            <GiJewelCrown style={{ marginRight: "10px" }} />
            <span>Grains</span>
          </Hold>
          <Hold>
            <GiJewelCrown style={{ marginRight: "10px" }} />
            <span>Oils</span>
          </Hold> */}
        </ExploreHold>
      </Container>
    </div>
  );
};

export default ProductCats;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

const Hold = styled.div`
  height: 35px;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #123456;
  color: white;
  border-radius: 30px;
  cursor: pointer;
  margin-right: 10px;
  margin-left: 10px;
`;

const ExploreHold = styled.div`
  /* width: 100%;
  height: 50px; */
  background-color: white;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  /* border-radius: 30px; */
  /* display: flex;
  justify-content: space-around;
  align-items: center; */

  margin-top: 50px;
  display: flex;
  overflow-x: scroll;
  justify-content: center;
  align-items: center;
  width: 100%;
  ::-webkit-scrollbar {
    width: 0;
  }
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
